import type { ButtonHTMLAttributes, ReactNode } from "react";

type ActionButtonVariant = "primary" | "secondary";

interface ActionButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	variant?: ActionButtonVariant;
	isDarkMode?: boolean;
	children: ReactNode;
}

export default function ActionButton({
	variant = "primary",
	isDarkMode = false,
	children,
	className = "",
	style,
	...props
}: ActionButtonProps) {
	const baseStyles =
		"btn-3d flex items-center justify-center gap-1.5 px-4 py-2.5 text-sm font-medium rounded-lg whitespace-nowrap transition-opacity disabled:opacity-50 cursor-pointer";

	if (variant === "secondary") {
		return (
			<button
				{...props}
				className={`${baseStyles} ${
					isDarkMode
						? "text-white bg-gray-800 border border-gray-700 shadow-[0_3px_0_0_#374151]"
						: "text-t-primary bg-white border border-gray-300 shadow-[0_3px_0_0_#d1d5db]"
				} ${className}`}
				style={{
					fontFamily: "var(--font-body)",
					fontWeight: "var(--font-body-weight)",
					...style,
				}}
			>
				{children}
			</button>
		);
	}

	return (
		<button
			{...props}
			className={`${baseStyles} ${className}`}
			style={{
				color: "var(--color-t-on-primary, #ffffff)",
				backgroundColor: "var(--color-accent, #e17100)",
				boxShadow:
					"0 3px 0 0 color-mix(in srgb, var(--color-accent, #e17100) 70%, black)",
				fontFamily: "var(--font-body)",
				fontWeight: "var(--font-body-weight)",
				...style,
			}}
		>
			{children}
		</button>
	);
}
